module.exports = __webpack_public_path__ + "site/img/42.b1da80dc.jpg";